import { DecimalPipe } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CatalogProduct } from '../../core/models/catalog.model';
import { salePercent } from '../../core/utils/money.util';

@Component({
  selector: 'app-product-card',
  imports: [RouterLink, DecimalPipe],
  host: {
    class:
      'product-grid-item product basel-hover-alt purchasable product-type-simple col-md-3 col-sm-4 col-xs-6'
  },
  templateUrl: './product-card.component.html'
})
export class ProductCardComponent {
  readonly product = input.required<CatalogProduct>();
  readonly add = output<CatalogProduct>();

  readonly salePercent = salePercent;

  onAdd(event: Event): void {
    event.preventDefault();
    this.add.emit(this.product());
  }
}
